import { useMemo } from "react"
import { Box, useTheme } from "@mui/material"
import { AppNavigation as DefaultAppNavigation } from "containers/kiosk-h"
import { getPostDetail } from "utils/feature"
import { useTranslation } from "providers/i18n"

import { PageCard, PageCardContent } from "components/card"
import { SidebarMenu } from "extensions/iconsiam/components/navigation/kiosk-h/SidebarMenu"
import { MotionDiv } from "components/motions"

// --- Swiper ---
import { Swiper, SwiperSlide } from "swiper/react"
import { EffectCards, Autoplay } from "swiper/modules"
import "swiper/css"
import "swiper/css/effect-cards"
import { LuxuryCard } from "extensions/iconsiam/components/domains/luxury/Card"
import { EmptyData } from "components/EmptyData"
import { ServiceIcon } from "components/icons"
import { getIcon } from "utils/icon"
import { useLuxury } from "extensions/iconsiam/hooks/luxury"

const transformLuxury = (data) => {
  const { id, ...rest } = getPostDetail(data)

  return {
    ...rest,
    id,
    locationUrl: `/luxury/${id}`,
  }
}

export const LuxuryKioskHPage = ({
  Layout = Box,
  AppNavigation = DefaultAppNavigation,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const { hasData, luxurySlides, loop, autoPlay } = useLuxury()
  const styleOverrides = theme.components[`LuxuryPage`]?.styleOverrides || {}
  const {
    pageCard,
    pageCardContent,
    motionDivStyle,
    emptyDataWrapper,
    swiperWrapper,
  } = styleOverrides
  const emptyIcon = useMemo(
    () => getIcon(theme?.assets?.empty?.luxury) || <ServiceIcon />,
    [theme]
  )

  const direction = theme.direction

  return (
    //@ts-ignore
    <Layout
      aside={
        <PageCard>
          <SidebarMenu AppNavigation={AppNavigation} />
        </PageCard>
      }
    >
      <PageCard sx={pageCard}>
        <PageCardContent sx={pageCardContent}>
          <MotionDiv
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.15 }}
            sx={motionDivStyle}
          >
            {hasData ? (
              <Box sx={swiperWrapper}>
                <Swiper
                  key={`luxury-swiper-${direction}`}
                  effect={"cards"}
                  grabCursor={true}
                  modules={[EffectCards, Autoplay]}
                  autoplay={autoPlay}
                  className="LuxuryPage-swiper"
                  loop={loop}
                  speed={750}
                  dir={direction}
                  cardsEffect={{
                    slideShadows: false,
                    rotate: true,
                    perSlideOffset: 101,
                    perSlideRotate: 4,
                  }}
                  onInit={(swiper) => {
                    const activeSlide = swiper.slides[swiper.activeIndex]
                    if (activeSlide) {
                      activeSlide.style.height = "100%"
                    }
                  }}
                >
                  {luxurySlides.map((luxury, idx) => {
                    return (
                      <SwiperSlide key={idx}>
                        <LuxuryCard data={transformLuxury(luxury)} />
                      </SwiperSlide>
                    )
                  })}
                </Swiper>
              </Box>
            ) : (
              <Box sx={emptyDataWrapper}>
                <EmptyData
                  icon={emptyIcon}
                  primary={t(`No Current Luxury`)}
                  secondary={t("Check Back Soon")}
                />
              </Box>
            )}
          </MotionDiv>
        </PageCardContent>
      </PageCard>
    </Layout>
  )
}
